import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
  getToken,
  setToken,
  getVisitorToken, getAppId, getExhibitionId, noEnterRouter,
  getWhiteList,
  workBenchList,
  getRegSetIdentityList,
  isPathMatched, visitorRegisterAuthority
} from '@/utils/auth'
import business from '@/utils/business'
import config from './config/index'
import { getVisitorAuditState, getUserInfo } from '@/api/index'
import visitorHead from '@/assets/images/person.png'
import actorHead from '@/assets/images/actor.png'
window.PC.Cancel = []

NProgress.configure({ showSpinner: false })

//初始化设置
; (function () {
  // 设置展会id
  store.commit('SET_EXHIBITIONID', getExhibitionId())
  // 设置应用id
  store.commit('SET_APPID', getAppId())
})()

/**
 * 每次页面跳转都初始化token
 */
const tokenInit = function (to) {
  const visitorToken = getVisitorToken();
  let token = getToken()
  // 判断当前路由角色是否是游客
  if (!noEnterRouter('', to)) {
    let t = !store.getters.isLogin && (!store.getters.info || (store.getters.info && !store.getters.info.id))
    if (!token || t) {
      token = visitorToken
      setToken(token)
    }
    // 设置身份 展商(ACTOR)、客商(VISITOR)、游客(空字符串)
    if (token == visitorToken) {
      store.commit('SET_SUBJECTTYPE', '')
    }
  }

  return token
}

// const tokenInit = function (to) {
//   let token = getToken()
//   let subjectType = store.getters.subjectType
//   // 判断当前路由角色是否是游客
//   if (!noEnterRouter('', to)) {
//     const visitorToken = getVisitorToken()
//     const t = !business.isLoginStatus()
//     if (!token || t) {
//       token = visitorToken
//       store.commit('SET_TOKEN', '')
//     }
//     // 设置身份 展商(ACTOR)、观众(VISITOR)、游客(空字符串)
//     if (token === visitorToken && subjectType !== '') {
//       store.commit('SET_SUBJECTTYPE', '')
//     }
//   }

//   if (!['', 'VISITOR', 'ACTOR'].includes(subjectType)) {
//     store.commit('SET_SUBJECTTYPE', '')
//   }

//   return token
// }

export const getUserInfoFn = async function () {
  await getUserInfo().then(event => {
    const data = event.data.data
    const subjectType = data.subjectType

    store.commit('SET_USER_INFO', 'y')
    store.commit('SET_INFO', data.exhibitionUserRegister)
    store.commit('SET_SUBJECTTYPE', subjectType)
    store.commit('SET_NAME', data.name)
    store.commit('SET_EXHIBITORID', data.exhibitorId)
    // store.commit('SET_CONFIGSWITCH', data.configSwitch)
    store.commit('SET_ISLOGIN', '1')
    if (localStorage.getItem('info')) {
      if (subjectType === 'ACTOR') {
        store.commit('SET_HEADIMG', store.getters.info.userInfo.headImage || actorHead)
      } else if (subjectType === 'VISITOR') {
        store.commit('SET_HEADIMG', store.getters.info.visitor.headImage || visitorHead)
      }
    }
    // if ((!store.state.sendingUser || (store.state.sendingUser && store.state.imRole === 'tourist')) && store.state.isChatConnecting !== 'waiting') {
    //   store.dispatch('chatLogin', store.getters.imAccount)
    // }
    if (!store.getters.isSDKReady) {
      store.dispatch('getOnlineCustomer', store.getters.isLogin)
      console.log('permission页面登录')
    }
  }).then(() => {
    console.log('================getUserInfoByToken=================')
    // setTimeout(() => {
    //   window.location.href = window.location.href.split('?')[0]
    // }, 100)
    // console.log(window.location.href.split('?'))
  }).catch(() => {})
}

// 白名单 不需要登录
const whiteList = getWhiteList()
// // 注册流程中需要强制设置身份的路由
const regSetIdentityList = getRegSetIdentityList()

router.beforeEach(async (to, from, next) => {
  console.log('store.getters.setuserinfo--->', store.getters)
  console.log('getVisitorToken()--->', getVisitorToken())
  console.log('getToken()--->', getToken())

  if (store.getters.setuserinfo === 'n') {
    if (getToken()) {
      if (getVisitorToken() != getToken()) {
        await getUserInfoFn()
      }
    }
  }

  // 移至indexHeader头部组件

  // 是否已登录 
  // if (store.getters.isLogin) {
  //   console.log(to.path, 'to.path')
  //   console.log(to, 'to')
  //   // 找展品【findList】、找展商【findList】、商脉圈【findOpportunity】、展商详情【findExhibitorDetail】、展品详情【findExhibitDetail】、采购对接会【purchaseMeeting】
  //   if (['findList', 'findOpportunity', 'findExhibitorDetail', 'findExhibitDetail',].includes(to.name)) {
  //     try {
  //       // 通过token获取个人信息 设置操作权限
  //       await getUserInfoFn()
  //     } catch (error) {
  //       console.log(error)
  //     }
  //   }
  // }
  

  console.log("localStorage.getItem('language')--->", localStorage.getItem('language'))
  console.log("store.getters.language--->", store.getters.language)
  if (localStorage.getItem('language') !== store.getters.language) {
    if (localStorage.getItem('language')) {
      store.commit('SET_LANGUAGE', localStorage.getItem('language'))
    } else {
      store.commit('SET_LANGUAGE', store.getters.language)
    }
    // location.reload()
  }
  while (window.PC.Cancel.length > 0) {
    window.PC.Cancel.shift()('cancel')
  }

  // 是否开启禁止访问页面
  if (config.settings.noAction && to.path != '/') {
    next({ path: '/' })
    return
  }

  // 是否开发展商限制
  if (config.settings.noActor && !business.ActorNoTodo(true)) {
    store.dispatch("LogOut").then(() => {
      next({ path: '/' })
    })
    return
  }
  tokenInit(to)
  const subjectType = store.getters.subjectType
  NProgress.start()
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    let lastChat = to.meta.title.substr(to.meta.title.length - 1, 1)
    if (lastChat === '.') {
      document.title = window.PC.$t2(to.meta.title + to.params.type)
    } else {
      document.title = window.PC.$t2(to.meta.title)
    }
  }
  /**
   * 存在token
   * 且 是登录状态
   * 且 存在用户信息 且 存在用户id
   * 且 存在身份(ACTOR, VISITOR)
   * token && (store.getters.isLogin && store.getters.info && store.getters.info.id) && subjectType
   */
  if (business.isLoginStatus()) {
    if (['/login', '/login/person', '/login/actor'].includes(to.path)) {
      next({ path: '/' })
      NProgress.done()
    } else {
      // 黑名单
      if (noEnterRouter(subjectType, to)) {
        next({ path: '/' })
      } else {
        
        // 客商注册流程页面访问的权限
        if (!visitorRegisterAuthority(subjectType, store.getters.info, to)) {
            next({ path: '/' })
            NProgress.done()
            return false
        }

        /**
         * 用户权限判断
         * 是否完成预登记
         */
        const status = workBenchList(subjectType, store.getters.info, to)
        if (status === true) {
          // 完成预登记
          next()
        } else {
          // 未预登记
          if (status === false) {
            window.PC.noUnregisteredDiag(() => {
              // business.loginSuccess(subjectType, {}, null, { secondInfo: true })
              console.log(business, 'business')
              business.toRegistion()
            })
          }

          /**
           * 客商完成预登记 没有审核通过/待审核
           * 且 来自登录页面/问卷页面
           * 直接调转首页
           */
          // const t = from.name == 'login' || from.name == 'questionnaire'
          // if (t) {
          //   next({ path: '/' })
          //   NProgress.done()
          //   return false
          // }

          // 国内用户 完成预登记 审核未通过
          // if (status === 1) {
          //   window.PC.noUnregisteredDiag(() => {
          //   }, null, 'auditTip1', 'ok')
          // }

          // 国内用户 完成预登记 待审核
          // if (status === 2) {
          //   window.PC.noUnregisteredDiag(() => {
          //     // 通过接口判断是否审核通过
          //     getVisitorAuditState().then(res => {
          //       return res.data
          //     }).then(res => {
          //       if (!res.data) return
          //       let info = store.getters.info
          //       info.visitor.auditState = res.data
          //       switch (res.data) {
          //         case 'APPROVE':
          //           // 审核通过
          //           store.dispatch('LogOut').then(() => {
          //             business.loginSource({ replaceStatus: true })
          //           })
          //           break
          //         case 'DISAPPROVE':
          //           // 审核不通过
          //           store.commit('SET_INFO', info)
          //           break
          //       }
          //     })
          //   }, null, 'auditTip', 'ok')
          // }

          next({ path: from.path })
          NProgress.done()
        }

      }
    }
    // TODO
    // setTimeout(() => {
    //   if ((!store.state.sendingUser || (store.state.sendingUser && store.state.imRole === 'tourist'))
    //     && store.state.isChatConnecting !== 'waiting') {
    //     store.dispatch('chatLogin', store.getters.imAccount)
    //   }
    // }, 0)
    if (!store.getters.isSDKReady) {
      store.dispatch('getOnlineCustomer', store.getters.isLogin)
      console.log('permission页面登录')
    }
    
  } else {
    // 未登录状态

    const toLogin = function () {
      window.sessionStorage.setItem('toPath', to.path);
      next(`/login/person`)
      NProgress.done()
    }

    const noLogin = function () {
      // 游客的token
      if (isPathMatched(whiteList, to.path)) {
        /**
         * 进入之前判断 是否有身份
         * 是 在免登录白名单，直接进入
         * 否 跳转登录
         * 
         * 进入设置密码页面不需要身份
         * 如果在setTypeList中，强制设置身份
         */
        if (!subjectType && noEnterRouter(subjectType, to) && !isPathMatched(regSetIdentityList, to.path)) {
          toLogin()
        } else {
          if (isPathMatched(regSetIdentityList, to.path)) {
            if (to.params.type == 'vis') {
              store.commit('SET_SUBJECTTYPE', 'VISITOR')
            } else if (to.params.type == 'actor') {
              store.commit('SET_SUBJECTTYPE', 'ACTOR')
            }
          }
          next()
        }
      } else {
        toLogin()
      }
    }

    /**
     * 未登录状态
     * 且 (登录状态 或 存在用户信息且存在用户id 或没有身份) 时 需要退出重新登录
     * 否 需要去登录
     *  || !subjectType
     */
    if (store.getters.isLogin || (store.getters.info && store.getters.info.id)) {
      store.dispatch("LogOut").then(() => {
        tokenInit(to)
        noLogin()
      })
    } else {
      noLogin()
    }
  }

})

/* eslint-disable-next-line */
router.afterEach((to, from) => {
  // 自动更换语音
  // let changeLanguage = ['changeQuestionnaire', 'questionnaire', 'checkYDJ', 'account-info']

  // if (changeLanguage.includes(from.name)){
  //   /**
  //    * 判断离开页面时 是否来自问卷页面 且 本地语言 与 旧的本地语言不一致
  //    * 用旧的本地语言覆盖本地语言
  //    * 且 刷新页面
  //    */
  //   let f = to.path != '/questionnaire'
  //   let language    = store.getters.language
  //   let languageOld = store.getters.languageOld
  //   if (f && language != languageOld) {
  //     store.commit('SET_LANGUAGE', languageOld)
  //     window.location.reload()
  //   }

  //   if (f) {
  //     sessionStorage.removeItem('langChange')
  //   }
  // }

  /**
   * 广告分享链接统计浏览（主页和登录页面）
   */
  window.PC.$RangersEvent('predefinePageView')

  business.hostAdvertisingSharingStatistics()
  NProgress.done()
})
